import { render, staticRenderFns } from "./RelevantBizList.vue?vue&type=template&id=48f38ebb&scoped=true&"
import script from "./RelevantBizList.vue?vue&type=script&lang=js&"
export * from "./RelevantBizList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f38ebb",
  null
  
)

export default component.exports